import React from "react";

function MildIcon({ className }: { className: string }) {
  return (
    <svg className={className} viewBox="0 0 37.732 37.732">
      <ellipse cx="18.866" cy="18.866" rx="18.866" ry="18.866" fill="#ffa439" />
      <path
        d="M17.814,4.76A13.054,13.054,0,1,0,30.867,17.814,13.054,13.054,0,0,0,17.814,4.76Zm0,24.239A11.185,11.185,0,1,1,29,17.814,11.185,11.185,0,0,1,17.814,29Z"
        transform="translate(1.052 1.052)"
        fill="#fff"
      />
      <ellipse
        cx="1.868"
        cy="1.868"
        rx="1.868"
        ry="1.868"
        transform="translate(12.345 15.142)"
        fill="#fff"
      />
      <ellipse
        cx="1.868"
        cy="1.868"
        rx="1.868"
        ry="1.868"
        transform="translate(21.662 15.142)"
        fill="#fff"
      />
      <line
        y1="1.819"
        x2="6.814"
        transform="translate(16.07 22.395)"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="1.5"
      />
    </svg>
  );
}

export { MildIcon };
